import { Link } from "react-router-dom";
import FeedbackForm from "@/pages/about/components/FeedbackForm";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

const stats = [
  { label: "收录国产影视", value: "18+", icon: "ri-movie-2-line" },
  { label: "覆盖类型", value: "30+", icon: "ri-price-tag-3-line" },
  { label: "持续更新", value: "每日", icon: "ri-refresh-line" },
  { label: "高清片源", value: "1080P", icon: "ri-hd-line" },
];

const values = [
  {
    icon: "ri-focus-3-line",
    title: "专注国产",
    desc: "只做国产影视，扎根中国故事，把优质的本土影视内容集中呈现给观众。",
  },
  {
    icon: "ri-search-eye-line",
    title: "便捷发现",
    desc: "多维筛选与关键词搜索相结合，让你用最短的时间找到想看的那一部。",
  },
  {
    icon: "ri-sparkling-line",
    title: "持续更新",
    desc: "紧跟院线与卫视节奏，热门电影、电视剧和综艺节目第一时间上架更新。",
  },
];

export default function About() {
  useDocumentMeta(
    "关于我们 - 国产在线观看",
    "了解国产在线观看的网站定位、发展目标与联系方式，我们致力于打造专业的国产影视在线观看信息平台。"
  );

  return (
    <div className="mx-auto w-full max-w-[1280px] px-4 py-6 md:px-6 md:py-8">
      <nav aria-label="面包屑" className="flex items-center gap-1.5 text-xs text-foreground-500">
        <Link to="/" className="transition-colors hover:text-primary-600">
          首页
        </Link>
        <i className="ri-arrow-right-s-line" aria-hidden="true" />
        <span className="text-foreground-800">关于我们</span>
      </nav>

      <header className="mt-4">
        <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          关于国产在线观看
        </h1>
        <p className="mt-2 max-w-3xl text-sm leading-relaxed text-foreground-600">
          我们是一个专注于国产影视作品的在线观看信息平台，聚合高清国产电影、电视剧与综艺节目资源，
          帮助观众方便快捷地发现、浏览和了解喜欢的国产影视内容。
        </p>
      </header>

      <section className="mt-6 grid grid-cols-2 gap-4 lg:grid-cols-4">
        {stats.map((s, i) => (
          <div
            key={s.label}
            className={`rounded-lg border p-5 ${
              i % 2 === 0
                ? "border-background-200 bg-background-50"
                : "border-accent-200 bg-accent-50"
            }`}
          >
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className={`${s.icon} text-xl`} aria-hidden="true" />
            </span>
            <p className="mt-3 font-heading text-2xl font-bold text-foreground-950">{s.value}</p>
            <p className="mt-0.5 text-xs text-foreground-500">{s.label}</p>
          </div>
        ))}
      </section>

      <div className="mt-8 grid gap-6 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <section className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
            <h2 className="font-heading text-lg font-bold text-foreground-950">网站介绍与发展目标</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              国产在线观看创立之初，就希望为喜爱国产影视的观众打造一个清爽、好用的发现平台。
              我们相信，优秀的国产影视作品值得被更多人看到，而找到它们的过程，不该被繁杂的信息淹没。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              为此，我们把重点放在"发现效率"上：清晰的分类、多维的筛选、准确的搜索，让每一次浏览都更接近你想看的内容。
              未来，我们还将持续扩充片库、优化推荐机制，并引入更丰富的内容标签与榜单，让国产影视资源触手可及。
            </p>
            <div className="mt-5 grid gap-4 sm:grid-cols-3">
              {values.map((v) => (
                <div key={v.title} className="rounded-lg bg-secondary-50 p-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                    <i className={`${v.icon} text-lg`} aria-hidden="true" />
                  </span>
                  <h3 className="mt-3 font-heading text-sm font-bold text-foreground-950">{v.title}</h3>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600">{v.desc}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="mt-6 rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
            <h2 className="font-heading text-lg font-bold text-foreground-950">法律声明与版权信息</h2>
            <ul className="mt-3 space-y-2 text-sm leading-relaxed text-foreground-700">
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 shrink-0 text-primary-500" aria-hidden="true" />
                本站为影视信息聚合与展示平台，不提供真实视频播放、下载、付费或会员服务。
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 shrink-0 text-primary-500" aria-hidden="true" />
                站内所有影视资料均为虚拟示范数据，仅用于产品演示，与真实作品无关。
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 shrink-0 text-primary-500" aria-hidden="true" />
                如涉及真实版权问题，请通过下方邮箱与我们联系，我们将及时处理。
              </li>
            </ul>
          </section>
        </div>

        <aside className="space-y-6">
          <section className="rounded-lg border border-background-200 bg-background-50 p-5">
            <h2 className="font-heading text-lg font-bold text-foreground-950">联系方式</h2>
            <ul className="mt-3 space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <i className="ri-mail-line mt-0.5 text-lg text-primary-500" aria-hidden="true" />
                <div>
                  <p className="text-foreground-500">反馈邮箱</p>
                  <a
                    href="mailto:feedback@guochan-online.example.com"
                    className="font-medium text-foreground-900 transition-colors hover:text-primary-600"
                  >
                    feedback@guochan-online.example.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-line mt-0.5 text-lg text-primary-500" aria-hidden="true" />
                <div>
                  <p className="text-foreground-500">服务时间</p>
                  <p className="font-medium text-foreground-900">每日 09:00 - 21:00</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line mt-0.5 text-lg text-primary-500" aria-hidden="true" />
                <div>
                  <p className="text-foreground-500">内容运营</p>
                  <p className="font-medium text-foreground-900">国产在线观看内容团队</p>
                </div>
              </li>
            </ul>
          </section>

          <FeedbackForm />
        </aside>
      </div>
    </div>
  );
}